export default {
  login: {
    title: "Login",
    remember: "remember me",
    button: "Login",
  },

  //new
  register: {
    title: "Member Register",
    password: "Password",
    password2: "Please enter the password once for confirmation",
    email: "Email Address",
    return_login: "Return to Login",
    english: "English",
    japanese: "Japanese",
    usernameRule: "Please enter username",
    usernamePattern: "Username consists of numbers and letters",
    emailRule: "Please enter email address.",
    emailPattern: "Please enter correct email address.",
    passwordRule: "Please enter password",
    passwordPattern: "The password consists of numbers and letters and has 4 or more digits.",
    registerAlert: "Please open your registered mailbox and activate your account.",
    userAlert: "The user name is duplicated, registration failed.",
    emailAlert: "The email address is duplicated, registration failed.",

    registerFail: "Register Failed!",
    passwordFail: "Password don't match.",
    server_not_found: "Server Not Found ⊙﹏⊙∥!",

    success: "Success",
    fail: "Fail!",
  },

  //new
  forget: {
    title: "Please fill email to reset.",
    hint: "If you have forgotten your ID and password, enter the same information as the registered member information and click the 'Send' button.",
    button: "Send",
    return: "Return to Login",
    emailRule: "Please fill email.",
    refill: "Please fill valid email.",
    alertMsg: "Open the registered mailbox and reset the user name and password.",
    not_email: "The registered email doesn't exist",
    server_not_found: "Server Not Found ⊙﹏⊙∥!",

    success: "Success!",
    fail: "Fail!",
  },

  //new
  reset: {
    title: "Reset user ID and password",
    button: "Confirm",
    username: "Username",
    password: "Password",
    confirm: "Please enter the password once for confirmation",
    return_login: "Return to Login",
    usernameRule: "Please enter username",
    passwordRule: "Please enter password",
    passwordPattern: "The password consists of numbers and letters and has 4 or more digits.",

    reset_completed: "Reseted username and password",
    usernameError: "Resetting failed because the user name is duplicated.",
    reset_failed: "Failed to reset user name and password!",

    success: "Success!",
    fail: "Fail!",

    server_not_found: "Server Not Found ⊙﹏⊙∥!",
    password_not_same: "The passwords entered twice do not match.",
  },

  //edit
  home: {
    system: "System",
    home: "Home",
    alert: "Welcome to SENSESystem",
    alert_info: "Information",
    msg: "Message",
    logout: "Logout",
    logout_confirm: "Are you sure to Logout?",
    guest: "Guest",
  },

  //new
  check: {
    forget: "Account Successfully Activated",
    hint: "Please click 「Login Page」.",
    mailed: "Email Confirmed. Please Login.",
    success: "Success",
    login_page: "Login Page"
  },
  empMana: {
    employee_id: "EmpID",
    cateName: "Name",
    employee_name_frgn: "Furigana",
    employee_name_rm: "Roman",
    employee_age: "Age",
    employee_gender: "Gender",
    month_salary: "Salary",
    employee_tel: "Telephone",
    bank_account: "Account",
    date: "Date",
    addbutton: "Add",
    editbutton: "Edit",
    detailsbutton: "Details",
    deletebutton: "Delete",
    deleteall: "DeleteAll",
    operation: "Operation",
    inputinfo: "please input the information...",
    cancel: "Cancel",
    confirm: "Confirm",
  },
  router: {
    laborIns: {
      title: "Labor Ins",
      insurance_rate: "Ins Rate",
      labor_ins_account: "LaborIns Account",
    },
    health: {
      title: "Health Insurance",
      HealthInsHome: "Health Insurance List",
      HealthIns1: "Insurance New Application",
      HealthIns2: "Insured Address Change Notification",
      HealthIns3: "Over 70 years old Registration",
      HealthIns4: "Request for confirmation of qualification acquisition/loss",
      HealthIns5: "Health insurance / National pension Dependent (Transfer) Notification",
      SuspensionNotice: "Suspension Notice",
      InsNameChange: "Insurance Name Change",
      InsDisqualifyNotice: "Insurance Disqualify Notice",
      InsQualifyNotice: "Insurance Qualify Notice",
      Childcare_Application: "Childcare Application",
      Childcare_Application_Salary_Change: "Childcare Application Salary Change",
    },
    empIns: {
      title: "Employee Insurance",
      empInsHome: "Employee Insurance List",
      empIns1: "Employee Insurance Changes",
      empIns2: "Employee Insurance Start",
      empIns3: "Turnover slip",
      empIns4: "Employee",
      empIns4: "Employment Insurance Insured Qualification Notification",
      empIns8: "Employment insurance exemption application",
      empIns10: "Summary vote for submission",
    },
    basic: {
      title: "Basic Information",
      company: "Company Information",
      homePage: "HomePage",
      laborIns: "LaborInsurance Information",
    },
    hr: {
      title: "HR Manager",
      list: "Employee List",
      empPDF: "Employee Information Print",
    },
    adj: {
      title: "Year-end Adjustment",
      gscsh: "Withholding slip",
      declaration: "Deduction for dependents",
      pensionadmin: "Calculation Basis Notification",
      pensionbasic: "Monthly Compensation Management",
      PensionReissue: "Pension certificate re-issue application",
      AttoneryPower: "Power of Attorney",
    },
    attendance: {
      title: "Attendance Management",
      manage: "Attendance Management",
    },
    user: {
      title: "User Management",
      manage: "User Management",
    },
    cacl: {
      title: "Calculation Function",
      nkhk: "Pension Insurance",
      jdsloan: "Car Loan",
      jtkloan: "Housing Loan",
      gscsh_month: "Withholding Tax (Monthly)",
    },
    social: {
      title: "Social Insurance",
      pension_reissue: "Pension Reissue",
      attorney_power: "Attonery Power",
    },
    detail: {
      manage: "Employee Details",
      empIns5: "Personal Number Registration/Change Notice",
      empIns6: "Reemployment Allowance Application Form",
      empIns7: "Application Establishment Abolition Notice",
      empIns8: "Exemption Application Form",
      empIns9: "Notification of Loss of Insured Status/Name Change",
      empIns10: "Summary vote for submission of qualification loss optical disk, etc.",
      empIns11: "Qualification acquisition report Optical disk submission target person list",
      empIns12: "Employment insurance insured transfer notice",
      empIns13: "Notification for foreigners who are insured by employment insurance",
      empIns14: "Notification for foreigners who are not insured by employment insurance",
    },
    sarary: {
      title: "Pension",
      pensionadmin: "PensionAdmin",
      pensionbasic: "PensionBasic",

    },
  },

  //these are variable that included common
  general: {
    select: "Please Select",
    preview: "Preview",
    refresh: "Refresh",
    add: "Create New",
    edit: "Edit",
    detail: "Detail",
    delete: "Delete",
    operation: "Function",
    print: "Print",
    inputinfo: "Please input the information...",
    cancel: "Cancel",
    confirm: "Confirm",
    print_completed: "Print Completed!",
    print_failed: "Print Failed!",
    hint: "Hint",
    sure_delete: "Are you sure to delete?",
    delete_completed: "Deleted!",
    canceled: "Canceled",
    close_comfirm: "Are you sure to close?",
    current_page: "Current Page:",
    add_completed: "Add Completed!",
    add_failed: "Add Failed!",
    edit_completed: "Edit Completed!",
    edit_failed: "Eidt Fail!",
    general_info: "General Information",
    please_select: "Please Select",
    detail: "Detail Info",
    hint: "Hint",
    warning: "Warning",
    empty_data: "Empty Data",
    valid_failed: "Required items have not been entered!",

    employee_id: "Employee ID",

    remark: "Remark",
    other: "Other",
    date: "Date",
    close: "Close"

  },

  //companyInfo
  //new
  companyInfo: {
    name: "Office Name", //Table
    addressT: "Head Office Address", //Table

    detail: "Detail Information",

    office_info: "Office Information",
    name1: "Office Name",
    name1P: "Please fill corporation name.",
    name_kn1: "Office Name (In English)",
    name_kn1P: "Please fill corporation name in english.",
    chairman: "Chairman Name",
    chairmanP: "Please fill chairman name.",
    chairman_ka: "Chairman Name (Phonetic)",
    chairman_kaP: "Please fill chairman name in phonetic.",
    chairman_code: "Corporation Code",
    company_code: "Company Code",
    establishment_date: "Establishment Date",
    end_date: "Business End Date",
    capital: "Capital",
    emp_amount: "Employee Amount",
    business_overview: "Business Overview",

    address: "Address",
    address1: "Address (City/Ward/Town,etc)",
    address2: "House No.",
    address3: "Building Name",
    address_frgn1: "Address(Phonetic)",
    address_frgn2: "House No.(Phonetic)",
    address_frgn3: "Building(Phonetic)",
    city: "City/Ward/Prefecture/Town Names",
    street: "Chome/Street",
    building: "Building,Mansion Names, etc",
    postal_code: "Postal Code",
    tel: "Telephone",

    insuranceInfo: "Insurance Information",
    emp_insurance_code: "Employee Insurance Code",
    emp_insurance_codeP: "Please fill emplopyee insurance code.",
    labor_insurance_code: "Lobor Insurance Code",
    labor_insurance_codeP: "Please fill labor insurance code",
    begin_day_emp: "Employee Start Day",
    begin_day_labor: "Labor Start Day",

    salary: "Salary/Tax",
    salary_close_day: "Salary Close Day",
    salary_day: "Pay Day",
    tax_office: "Jurisdiction Tax Office",
    tax_officeP: "If corporation please fill jurisdiction tax office name.",

    fill: "Please Fill.",

    open1Title: "Corporation Code is:",
    open1Msg: "(13) digit numbers which combine with inspection no.(1 digit) and company corporation no.(12 digit).",

    open2Title: "Employee Insurance Code is:",
    open2Msg: "Granted for business establishment 11 digit numbers (4digit-6digit-1digit). Example, 12345678901It is described in the “Applicable Business Office Ledger (Business Employment Insurance Applicable Business Establishment Report Registered Business Owner)”, “Notification of Acquiring Employment Insurance Insured Qualification (for Business Operator Notification)”, etc.",

    open3Title: "Lobor Insurance Code is:",
    open3Msg: "Total 14 digits with 2digit-1digit-2digit-6digit-3digit pattern.It is described in past labor insurance estimate/fixed insurance claim forms, workers' compensation insurance application forms, and labor insurance annual renewal forms.",

    open4Title: "Jurisdiction Tax Office is:",
    open4Msg: "The tax office that has jurisdiction is determined by the tax location to which you belong. If you have any questions, please check from the URL below：https://www.nta.go.jp/about/organization/access/map.htm",

    cant: "You can add only one company.",

    example: "Example......",

    company_code_example: "Eg.1236985866543",
    capital_example: "100000000 Yen",
    emp_amount_example: "100 People",
    business_overview_example: "Manufacturing Industry",
    postal_code_example: "000-0000",
    tel_example: "07012345678"
  },

  //Employee //HR Maganger
  empList: {
    close: "Shutdown",
    general_info: "General Information",
    name: "Name",
    name_rm: "Name (Phonetic)",
    name_frgn: "Name (Alphabet)",
    nation: "Nationality/Region",
    birthday: "Birthday",
    gender: "Gender",
    male: "Male",
    female: "Female",
    email: "Email Address",
    mynum: "My Number",

    nameP: "Please fill employee name",
    name_rmP: "Please fill name in phonetic",
    name_frgnP: "Please fill name in alphabet.",
    employee_idP: "Please fill employee ID.",
    birthdayP: "Please fill birthday.",
    emailP: "Please fill email address.",
    mynumP: "Please fill my number.",

    assign_resign: "Assign / Resign Information",
    begin_date: "Assign Date",
    end_date: "Resign Date",
    work_status: "Status of Enrollment",
    cause: "Turnover Reason",

    begin_dateP: "Please enter the date of joining the company.",
    end_dateP: "Please enter the date of lefting the company.",

    office_info: "Office Information",
    employee_type: "Employee Type",
    work_content: "Work Content",
    title: "Job Title",

    work_contentP: "Please fill work content",
    titleP: "Please fill job title",

    contact_info: "Contact Information",

    address1: "Address",
    address2: "House No.",
    address3: "Building Name",

    city: "City/Ward/Prefecture/Town Names",
    street: "Chome/Street",
    building: "Building,Mansion Names, etc",

    postal_code: "Postal Code",

    address_frgn1: "Address(Phonetic)",
    address_frgn2: "House No.(Phonetic)",
    address_frgn3: "Building(Phonetic)",

    tel: "Phone No.",
    telP: "Please fill phone number",

    salary: "Salary and Bank Account",
    bank_name: "Bank Name",
    deposit_type: "Deposit Type",
    account_name: "Account Name (Phonetic)",
    commuting_fee: "Commuting Allowance",
    bank_branch: "Bank Branch",
    account: "Account Number",
    salary_month: "Monthly Reward",
    salary_changeday: "Monthly Revision Date",

    resident_info: "Resident Information",
    resident: "Status of Residence",
    resident_code: "Resident Card No.",

    insurance_info: "Insurance Information",
    emp_insuranceID: "Employment Insurance No.",
    emp_ins_begin_day: "Employment insurance qualification acquisition date",
    emp_ins_end_day: "Unemployment insurance disqualification date",
    basic_pensionID: "Basic Pension No.",
    pensionID: "Welfare Pension Reference No.",
    health_insuranceID: "Health Insurance No.",

    basic_pensionIDP: "Please enter basic pension number",
    pensionIDP: "Please fill the employee pension reference number",
    health_insuranceIDP: "Please fill health insurance ID",

    family_info: "FamilyInfo",
    family_add: "Add Family",
    family_print: "Deduction Report",

    dependent_info: "Edit FamilyInfo",

    income: "Estimated Acquisition Price",
    relation: "Relationship",
    work: "The fact of making a living",

    social_ins_status: "Social Insurance Support Status",
    date: "The day no longer to be dependent",
    tax_status: "Income Tax Dependent Status",

    address: "Address",

    new_family_info: "New Family Information",

    aus: "AUS-Austria",
    bra: "BRA-Brazil",
    mmr: "MMR-Myanmar",
    can: "CAN-Canada",
    chn: "CHN-China",
    fra: "FRA-France",
    deu: "DEU-Germany",
    hkg: "HKG-Hong Kong",
    ind: "IND-India",
    jpn: "JPN-Japan",
    kor: "KOR-Korea",
    phl: "PHL-Philippines",
    twn: "TWN-Taiwan",
    tha: "THA-Thai",
    usa: "USA-America",
    vnm: "VNM-Vietnam",
    r1: "01-Proffesser",
    r2: "02-Artist",
    r3: "03-Religious Activities",
    r4: "04-Journalist",
    r5: "05-No.1 Highly Skilled Professional",
    r6: "06-No.2 Highly Skilled Professional",
    r7: "07-Investor/Business Manager",
    r8: "08-Legal/Accounting Services",
    r9: "09-Medical Services",
    r10: "10-Researcher",
    r11: "11-Instructor",
    r12: "12-Engineer/Specialist in Humanities/ International Services",
    r13: "13-Intra-company Transferee",
    r14: "14-Nursing care service",
    r15: "15-Entertainer",
    r16: "16-Skilled Labor",
    r17: "17-No.1 Specified Skilled Worker",
    r18: "18-No.2 Specified Skilled Worker",
    r19: "19-No.1 Technical Intern Training",
    r20: "20-No.2 Technical Intern Training",
    r21: "21-No.3 Technical Intern Training",
    r22: "22-Cultural Activities",
    r23: "23-Temporary Visitor",
    r24: "24-Student",
    r25: "25-Trainee",
    r26: "26-Dependent",
    r27: "27-Designated Activities",
    r28: "28-Permanent Resident",
    r29: "29-Spouse or Child of Japanese National",
    r30: "30-Spouse or Child of Permanent Resident",
    r31: "31-Long-Term Resident",

    none: "None",

    in_office: "In Office",
    on_leave: "On Leave",
    retired: "Retired",

    wife: "Wife",
    husband: "Husband",
    mother: "Mother",
    father: "Father",
    mother_in_law: "Mother-in-law",
    father_in_law: "Father-in-law",
    eldest_son: "Eldest Son",
    eldest_daughter: "Eldest Daughter",
    second_son: "Second Son",
    second_daughter: "Second Daughter",
    elder_brother: "Elder Borther",
    elder_sister: "Elder Sister",
    younger_brother: "Younger Brother",
    younger_sister: "Younger Sister",
    grandfather: "Grandfather",
    grandmother: "Grandmother",

    dont_support: "Don't Support",
    support: "Support",
    not_sure: "Not Sure",

    officer: "Officer",
    permanent: "Permanent",
    contract: "Contract",
    temporary: "Temporary",
    part_time: "Part-Time",

    deposit: "Deposit",
    checking: "Checking",
    savings: "Savings",

    nameRule: "Please fill name",
    work_statusRule: "Please fill work status",
    begin_dateRule: "Please fill the hire date",
    employee_typeRule: "Please fill employee type.",
    emailRule: "Please fill phonetic",
    name_rmRule: "Please fill with Alpabet",
    employee_idRule: "Please fill Employee ID",

    open1Title: "My Number is:",
    open1Msg: "My number is a 12-digit number that all people who have a resident card in Japan (including foreigners) have it. *In principle, you cannot change it freely.",

    open2Title: "Employment Insurance No. is:",
    open2Msg: "The insured number is a total of 11 digits, consisting of 「4 digits-6 digits-1 digit」. As a rule, one person is assigned to each person who joins the company and joins employment insurance, and the same insured number is used when re-entering employment insurance at the job transfer destination after retirement.",

    open3Title: "Basic Pension No. is:",
    open3Msg: "One number for each person, that is commonly used by all public pension systems such as national pension, welfare annuity insurance, and mutual aid association. Basic pension number system The basic pension number is a 10-digit number and is a combination of 4 and 6 digits.",

    open4Title: "Welfare Pension Reference Number:",
    open4Msg: "Check the copy of the employee pension qualification notification etc. Although it is often the same number as the health insurance insured reference number, it may differ, so please refer to the copy of the employee pension qualification acquisition notice.",

    open5Title: "Health Insurance No. is:",
    open5Msg: "You can find your health insurance number on the face of your health insurance card. In case of National Health Insurance Association, the part corresponding to the (number) in the (symbol/number) column on the front/upper part of the health insurance card is the health insurance insured reference number.",

    example: "Example......",
    postal_code_example: "000-0000",
    fill: "Please Fill"
  },

  //new
  empPDF: {
    name: "Name",
    name_frgn: "Name(Phonetic)",
    gender: "Gender",
    begin_date: "Start Day",
    history: "History",
    dismiss_date: "Dismiss/Retired/Death Date",
    address: "Address",
    birthday: "Birthday",
    work_content: "Work Content",
    dismiss_reason: "Dismiss/Retired/Death Reason"

  },


  //LaborIns
  //new
  laborInsInfo: {
    type: "Types",
    amount_labor: "Number of Labor Insurers",
    amount_emp: "Number of Employment Insurers",
    amount_old: "Number Of Elderly",
    business_overview: "Business Overview",
    business_type: "Business Type",
    total_money: "Amount of Sales",
    continued: "0:Insurance-related Establishment Notification (Continued)",
    fixed: "1:Insurance-related Establishment Notification (Fixed Term)",
    voluntary: "2:Voluntary Application Form",

    name: "Office Name",
    example: "Example......",

    people_example: "100 People",
    business_overview_example: "Manufacturing Industry",
    business_type_example: "Food Manufacturing Industry",
    total_money_example: "100000000 Yen",
  },
  labor_ins_account: {
    designated_deposit_account: "Designated deposit account",
    bank_account: "Bank Account",
    bank_code: "Bank Code",
    bank_store_code: "Bank Store Code",
    account_name_kana: "Account Name (Furigana)",
    account_name: "Account Name (Kanji)",
    bank_transfer_type: "Bank Transfer Type",

    transfer_payment_deadline: "Transfer payment deadline",
    bank_transfer_start_date: "Bank Transfer Start Date",
    era: "Era",
    year: "Year",
    term: "Term",
    bank_transfer_start_date_era: "Bank Transfer Start Date Era",
    bank_transfer_start_date_year: "Bank Transfer Start Date Year",
    bank_transfer_start_date_term: "Bank Transfer Start Date Term",
    submit_date: "Submission Date",
    employee_id: "Employee ID",
    name: "Employee Name",

    enter_employee_id: "Please enter Employee ID",
  },

  //HealthIns

  healthIns1: {
    general_info: "General Insformation",
    labor_ins_name: "Social Insurance Labor Consultant Name",
    health_ins_name_pho: "Health Insurance Association Name(Phonetic)",
    health_ins_name: "Health Insurance Association Name",
    welfare_pension_no: "Welfare Pension Fund Number",
    welfare_pension_name: "Welfare Pension Fund Name",
    allowrance: "Allowrance",
    food: "Food",
    housing: "Housing",
    clothing: "Clothing",
    commuter_pass: "Commuter Pass",
    other: "Other",
    allowrance1st: "Salary Raise: 1st Time",
    allowrance2nd: "Salary Raise: 2nd Time",
    allowrance3rd: "Salary Raise: 3rd Time",
    allowrance4th: "Salary Raise: 4th Time",
    bonus: "Planned Bonus",
    first: "1st Time",
    second: "2nd Time",
    third: "3rd Time",
    fourth: "4th Time",
    agent: "Business Agent",
    agent_name: "Business Agent Name",
    agent_address: "Business Agent Address",
    category: "Personal / Corporation",
    office_category: "Head / Branch Office",
    no_category: "Number",
    country_category: "Domestic / Foreign",
    remark: "Remark",
    not_exist: "Not Exist",
    exist: "Exist",
    corp: "Corporation",
    individual: "Personal",
    national: "National / Local Goverment",
    corp_no: "Corporation No.",
    company_no: "Company No.",
    main_office: "Head Office",
    branch_office: "Branch Office",
    domestic: "Domestic Corporation",
    foreign: "Foreign Corporation",
    otherHintTitle: "Other",
    otherHintMsg: "Please fill other type of allowrance.",
    agentHintTitle: "Business Agent",
    agentHintMsg: "Please fill name and address if select 'Exist'. ",
    div1HintTitle: "Personal / Corporation",
    div1HintMsg: "You don't need to fill the following information if select 'Personal'.",
  },
  healthIns2: {
    name: "Name",
    remark: "Remark",
    insured_info: "Insured Person Information",
    employee_id: "Employee ID",
    mynum: "My Number",
    birthday: "Birthday",
    before_address_pref: "Before Address「Prefecture」",
    before_address: "Before Address",
    change_post: "Changed Postal Code",
    change_address_pho: "Changed Address「Phonetic」",
    change_address_pref: "Changed Address「Prefecture」",
    change_address: "Changed Address",
    change_date: "Moving Date",
    other: "Other",
    spouse: "Changed Address Field for Dependent Spouse",
    s_last_name: "Last Name",
    s_first_name: "First Name",
    s_last_name_pho: "Last Name「Phonetic」",
    s_first_name_pho: "First Name「Phonetic」",
    together: "Isured Person and Spouse are Lliving Together",
    yes: "Yes",
    no: "No",
    short_term: "Short Term Stay",
    oversea: "Overseas Residence",
    other_resident: "Residence other than Resident Card Address",
    s_first_nameRule: "Please fill Spouse First Name.",
    s_last_nameRule: "Please fill Spouse Last Name.",
    s_last_name_knRule: "Please fill Spouse Last Name (Phonetic).",
    s_birthdayRule: "Please fill birthday.",
    s_before_address_prefRule: "Please fill before address (Prefecture).",
    s_before_addressRule: "Please fill before address.",
    change_postRule: "Please fill changed postal code.",
    change_address_phoRule: "Please fill changed address (Phonetic)",
    change_address_prefRule: "Please fill changed address (Prefecture).",
    change_addressRule: "Please fill changed address.",
    moving_dateRule: "Please select moving date.",
    remarkRule: "Please select remark.",
    otherRule: "Please fill other remark.",
    otherHintMsg: "Please fill other reason.",
  },
  healthIns3: {
    submission_date: "Submission Date",
    print_no: "Number of Employee to Print",
    office_name: "Office Name",
    chairman_name: "Chairman Name",
    person: "person",
    emp1: "Employee 1",
    emp2: "Employee 2",
    emp3: "Employee 3",
    emp4: "Employee 4",
    employee_id: "Employee ID",
    dependent: "Dependents",
    payment: "Payment",
    payment_amount: "Payment Amount",
    remark: "Remark",
    relevant_date: "Acquisition (Applicable) date",
    item: "Item",
    item_amount: "Item Amount",
    type: "Type",
    total: "Monthly Reward",
    other_remark: "Other Remark",
    postal_code: "Postal Code",
    address_pho: "Address (Phonetic)",
    address: "Address",
    reason: "Reason",
    other: "Other",
    other_reason: "Other Reason",

    note: "If you filled your My Number when submitting it to Japan Pension, you do not need to fill your address.",
    over70: "Applicable to employees over 70 years old",
    over_two: "Acquisition of two or more office workers",
    part_time: "Acquisition of part-time workers (Specific Applicable Establishments, etc.)",
    re_emp: "Acquisition of continuous re-employment after retirement",
    exist: "Exist",
    not_exist: "Not Exist",
    male: "Male",
    female: "Female",
    miner: "Miner",
    male_fund: "Male(Fund)",
    female_fund: "Female(Fund)",
    miner_fund: "Miner(Fund)",
    oversea: "Living Abroad",
    short_term: "Short-term Stay",
    print_noHint: "Please select the number of employee you want to print.",
    cant_change: "You can't change the number of employee to print.",
    detail: "Detail",
    totalHintMsg: "Payment Amount ＋ Item Amount",
    close: "Close",
  },
  healthIns4: {
    submission_date: "Submission Date",
    employee_id: "Insurance's Employee ID",
    name: "Insurance's Name",
    birthday: "Insurance's Birthday",
    relation: "Relationship",
    reason: "Reason",
    delegator_send_date: "Day to entrust insurer",
    relationship: "Relationship of the applicant and the insurer",
    other: "Other",
    empty_data: "Empty Data",
    family: "Family Information",
    f_name: "Name",
    f_birthday: "Birthday",
    close: "Close",
    self: "Person himself",
    emp: "The Employee",
    join: "Join the National Health Insurance (withdrawal) procedure",
    yes: "Yes",
    no: "No",
    apply_dateRule: "Please select application date.",
    delegator_send_dateRule: "Please select date to entrust the insurer.",
    relationRule: "Please select relationship of the applicant and the insurer.",
    reasonRule: "Please fill reason.",
    other_reasonRule: "Please fill other reason.",
    employee_idRule: "Please select Insurance's Employee ID",
  },
  healthIns5: {
    submission_date: "Submission Date",
    ins_info: "Insurance's Information",
    employee_id: "Employee Number",
    name: "Name",
    birthday: "Birthday",
    gender: "Gender",
    mynum: "My Number",
    acq_date: "Acquisition Date",
    income: "Annual Income",
    reference_no: "Insured Reference No.",
    spouse: "Dependent Spouse",
    deliver_date: "Deliver date",
    third_person: "Submission of No.3 insured persons related notice will be delegated to the spouse (No.2 insured person).",
    s_name: "Spouse's name",
    s_name_pho: "Spouse's name(Phonetic)",

    relation: "Relationship",
    other_relation: "Other Relationship",

    husband: "Husband",
    wife: "Wife",
    husband_s: "Husband(Husband Registration)",
    wife_s: "Wife (Wife Registration)",

    foreign_name: "Foreign Name",
    foreign_name_pho: "Foreign Name (Phonetic)",

    nationality: "Nationality",

    address: "Address",
    postal_code: "Postal Code",

    together: "Living Together",
    seperate: "Living Seperate",

    home: "Home",
    mobile: "Mobile",
    work: "Work",
    other: "Other",
    phone: "Phone No.",

    type: "Application Type",
    oversea_type: "Overseas Special Requirement Type",

    applicable: "Applicable",
    not_applicable: "Not Applicable",
    change: "Change",

    oversea_applicable: "Overseas Special Requirements Applicable",
    oversea_not_applicable: "Overseas Special Requirements Not Applicable",

    remark: "Remark",

    applicable_note: "If applicable, please fill in the following.",
    not_applicable_note: "If you are not applicable / change please fill out the following.",
    oversea_applicable_note: "Please fill out the following if applicable to overseas special requirements.",
    oversea_not_applicable_note: "Please fill in the following case of non-applicable to overseas special requirements.",

    d_become_date: "The day became dependent",
    d_change_date: "The day no longer to be dependent",

    oversea_become_date: "That day to overseas special requirements",
    oversea_change_date: "Not applicable Date overseas special requirements",

    reason: "Reason",
    marriage: "Marrigae",
    leave_job: "Leave Job",
    income_decrease: "Income Decrease",
    other_reason: "Other Reason",

    death: "Death",
    divorce: "Divorce",
    income_increase: "Income Increase",
    age_75: "75-year-old reached",
    failure: "Failure Certification",
    death_date: "Death Date",

    s_occupation: "Spouse's Occupation",
    employed: "Employed",
    unemployed: "Unemployed",
    part_time: "Part-time",
    pensioner: "Pensioner",
    other_occupation: "Other Occupation",


    study_abroad: "Study Abroad",
    acc_family: "Accompanying Family",
    specific: "Specific Activity",
    oversea_marriage: "Oversea Marriage",

    domestic_transfer: "Domestic Transfer",
    domestic_transfer_date: "Domestic Transfer Date",

    dependent1: "Dependent 1",
    dependent2: "Dependent 2",

    ins_last_name: "Insurance's Last name",
    ins_first_name: "Insurance's First name",
    ins_last_name_pho: "Insurance's Last name (Phonetic)",
    ins_first_name_pho: "Insurance's First name (Phonetic)",

    child: "Biological child/ Adopted child",
    other_child: "Child other than biological child, adopted child",
    parent: "Parents/ Adoptive parents",
    in_law: "Father-in-law / Mother-in-law",
    elder_sibling: "elder Sibling",
    younger_sibling: "Younger Sibling",
    grand_parent: "Grandparent",
    great_grand_parent: "Great-grandparent",
    grand_child: "Grandchild",

    birth: "New Born",
    d_income_decrease: "Income Decrease",
    elementary: "Elementary / Junior high school students",
    high: "High School / College students",
    grade: "Grade",

    d_employed: "Employed",
    d_income_increase: "Income Decrease",

    male: "Male",
    female: "Female",

    reference_noHint: "Please fill insured reference number issued when you obtained the qualification. It isn't necessary to fill in if you submit it together with the insured qualification acquisition report.",
    change_dateHint: "It is the day when no longer a dependent (No.3 insured).",
    become_dateHint: "It is the day when I became a dependent (No.3 insured).",
  },

  ins_disqualify_notice: {
    report_date: "Report Date",
    office_ref_num: "Office Reference Number",
    no_of_emp_to_print: "Number of employees to print",

    employee_id: "Employee ID",
    ins_ref_num: "Insurance Reference Number",
    loss_date: "Date of Loss",
    loss_cause: "Reason of Loss",
    retired_date: "Date of Retired",
    death_date: "Date of Death",
    remark: "Remark",
    remark_other: "Other remark",
    transfer_date: "Transfer Date",
    ins_card_collection_attachment: "Number of Insurance Card Collection",
    ins_card_collection_irreversible: "Number of Irreversible Card Collection",
    not_for_70_year: "Not Applicable for employees with more than 70 years old",
    not_for_70_year_date: "Date of Retired Or Date of Death",

    employee_id2: "Employee ID",
    ins_ref_num2: "Insurance Reference Number",
    loss_date2: "Date of Loss",
    loss_cause2: "Reason of Loss",
    retired_date2: "Date Of Retired",
    death_date2: "Date of Death",
    remark2: "Remark",
    remark_other2: "Other remark",
    transfer_date2: "Transfer Date",
    ins_card_collection_attachment2: "Number of Insurance Card Collection",
    ins_card_collection_irreversible2: "Number of Irreversible Card Collection",
    not_for_70_year2: "Not Applicable for employees with more than 70 years old",
    not_for_70_year_date2: "Date of Retired Or Date of Death",

    employee_id3: "Employee ID",
    ins_ref_num3: "Insurance Reference Number",
    loss_date3: "Date of Loss",
    loss_cause3: "Reason of Loss",
    retired_date3: "Date Of Retired",
    death_date3: "Date of Death",
    remark3: "Remark",
    remark_other3: "Other remark",
    transfer_date3: "Transfer Date",
    ins_card_collection_attachment3: "Number of Insurance Card Collection",
    ins_card_collection_irreversible3: "Number of Irreversible Card Collection",
    not_for_70_year3: "Not Applicable for employees with more than 70 years old",
    not_for_70_year_date3: "Date of Retired Or Date of Death",

    employee_id4: "Employee ID",
    ins_ref_num4: "Insurance Reference Number",
    loss_date4: "Date of Loss",
    loss_cause4: "Reason of Loss",
    retired_date4: "Date Of Retired",
    death_date4: "Date of Death",
    remark4: "Remark",
    remark_other4: "Other remark",
    transfer_date4: "Transfer Date",
    ins_card_collection_attachment4: "Number of Insurance Card Collection",
    ins_card_collection_irreversible4: "Number of Irreversible Card Collection",
    not_for_70_year4: "Not Applicable for employees with more than 70 years old",
    not_for_70_year_date4: "Date of Retired Or Date of Death",

    emp1: "Employee１",
    emp2: "Employee２",
    emp3: "Employee３",
    emp4: "Employee４",

    enter_office_ref_num: "Please enter Office Reference Number",
    enter_ins_ref_num: "Office Reference Number",

    hint_insRefNumMesg_title: "Insured reference number",
    hint_insRefNumMesg: "Insured reference number issued when qualifying",
    hint_lossDateMesg_title: "Loss Date",
    hint_lossDateMesg: "Loss of qualification due to retirement, etc. ⇒ Day after retirement, day of transfer, day of change of employment contract ｜ | Loss of qualification due to death ⇒ The day after death ｜ | Loss of health insurance qualification due to reaching the age of 75 ⇒ Day of birthday ｜ | Disability Loss of health insurance qualification due to certification ⇒ On the day of certification",
    hint_open3_title: "Retired Date",
    hint_open3: "When selecting retirement, enter the day after the retirement date.",
    hint_open4_title: "Date of Dead",
    hint_open4: "When selecting death, fill in the day after the date of death.",
    hint_open5_title: "Attached document",
    hint_open5: "'Health insurance insured card' for all of you and your dependents || If you cannot collect your health insurance insured card, then you will not be able to recover your health insurance insured card. || Lost your health insurance card If lost due to burglary, theft, etc., 'Notification of loss of health insurance insured person certificate' || If a health insurance elderly beneficiary certificate is issued, 'health insurance elderly beneficiary certificate'",
    hint_not70Year_title: "Not related with 70 Years Old",
    hint_not70Year: "If you are 70 years or older, select 'はい'.",
    hint_lossReasonMesg_title: "Loss Reason",
    hint_lossReasonMesg: "Please enclose the applicable number. (In case of retirement or death, please enter the date of the day.",
    hint_not70YearDateMesg_title: "Not related with 70 Years Old Date",
    hint_not70YearDateMesg: "Please enter the date of retirement or death.",
    hint_otherListMesg_title: "Remark",
    hint_otherListMesg: `If the insured working at two or more applicable establishments will be lost, select 「1.二以上事業所勤務者の喪失」.
      If you are 60 years or older and retired and continue to be rehired without a blank day, select 「2.退職後の継続再雇用者の喪失」 and add this notification along with "Notification of Acquisition of Person Qualification".
      If you lose your qualification due to transfer, select 「3.その他」, select 「1. 転勤により資格喪失する」 in 「備考その他」, and enter "Date of transfer".
      For insured persons who are members of the Employees' Pension Fund who lost their qualifications in the month when they acquired the qualifications of the insured, select 「3.その他」 and select 「2. 加入員の資格同月得喪」.
      `
  },

  ins_name_change: {
    office_ref_num: "Office Reference Number",
    ins_ref_num: "Insured Reference Number",
    title_name: "Insured person (Name before change and Name after change)",
    first_nm_mae: "First name before change",
    last_nm_mae: "Last name before change",
    first_nm_go: "First name after change",
    last_nm_go: "Last name after change",
    first_nm_furi: "First name after change(Furigana)",
    last_nm_furi: "Last name after change(Furigana)",
    type: "Gender Type",
    remark: "Remark",
    submit_date: "Submit Date",
    employee_id: "Employee ID",
    name: "Employee Name",
    enter_office_ref_num: "Please enter the office reference number!!",
    enter_ins_ref_num: "Please enter the insured reference number!!",
    enter_first_nm_go: "Please enter the insured first name!!",
    enter_last_nm_go: "Please enter the insured last name!!",
    hint_open1: "Please fill in your insured card!!",
    hint_open2: "Please choose “1” when the insured is a boy, “2” when it is a female, and “3” when it is a mine member. However, if you are a member of the welfare pension fund and you are a boy other than a mine member, you get ",
    gender_type: "Gender Type",
  },

  ins_qualify_notice: {
    application_date: "Application Date",
    office_ref_num: "Office Reference Number",
    message1: "Please enter the office number!!",
    message2: "Please enter the Employee ID",
    qualify_date: "Qualify Date",
    employee_id: "Employee ID",
    name: "Employee Name",
  },

  suspension_notice: {
    office_ref_num: "Office Reference Number",
    report_date: "Report date",
    resume_date: "Date",
    zensou_name: "Name",
    zensou_date: "Birth Date",
    zensou_postcode: "Post Code",
    zensou_address: "Address",
    zensou_tele: "Phone Number",
    reason: "Reason",
    zensou_causes: "Causes",
    // resume_date: "事業再開見込年月日",
    enter_office_ref_num: "Please enter Office Reference Number",
    hint_open1: "If the Cause of loss is '休業2', enter the expected date of restarting the business.",
    hint_open2: "Please describe the reason for the loss in detail. Example (As the business performance continued to deteriorate due to the recent economic recession, it became difficult to meet the financing conditions of financial institutions, so we decided to close the business and the company was dissolved.)",
    hint_reasonMesg: `解散 1: When business is abolished or corporation is dissolved ||
          休業 2: When the business is suspended (closed) ||
          合併 3: When merged with another business site ||
          任適脱退認可 4: When voluntary application places an application for cancellation of authorization ||
          一括適用 8: When two or more applicable establishments of the same employer are approved as one establishment`,
    information_losses: "Information of Losses",
    not_applicable_over_70_years: "70 years old Not applicable",
  },

  Childcare_Applicationde: {
    Basicinformation: "Basic information",
    Insuredreferencenumber: "Insured reference number",
    Selectemployee: "Select employee",
    holidaystarttime: "Holiday start time",
    scheduledendtime: "Scheduled end time",
    childinformation: "Child information",
    familyname: "Family Name",
    category: "Category",
    childbirthday: "Child Birthday",
    thedateofparenting: "The date of parenting(Other than real child)",
    givenname: "Given Name ",
    note: "Note",
    others: "Others",
    pplicabletomaternityleave: "Applicable to maternity leave",
    incaseofpostponement: "In case of postponement or early termination",
    actualenddate: "Actual end date",
    operating: "Operating",
    detail: "Detail",
    edit: "Edit",
    print: "Print",
    create: "Create",
    cancle: "Cancle",
    logicnumber: "Logicnumber",
    update: "Update",
    ok: "OK",
    review: "Review",

  },
  Childcare_Application_Salary_Changede: {
    Basicinformation: "Basic Information",
    Insuredreferencenumber: "Insured Reference Number",
    Selectemployee: "Select Employee",
    holidaystarttime: "Holiday Start Time",
    scheduledendtime: "Scheduled End Time",
    childinformation: "Child Information",
    familyname: "Family Name",
    category: "Category",
    childbirthday: "Child Birthday",
    thedateofparenting: "The date of parenting(Other than real child)",
    givenname: "Given Name ",
    note: "Note",
    others: "Others",
    incaseofpostponement: "In case of postponement or early termination",
    salarychange: "Salary Change",
    actualenddate: "Actual End Date",
    attendancemonth: "Attendance Month",
    attendancedays: "Attendance Days",
    currency: "Currency",
    spot: "Spot",
    total: "Total",
    grandtotal: "Grandtotal",
    averageamount: "Average Amount",
    revisedaverage: "Revised Average",
    operating: "Operating",
    detail: "Detail",
    edit: "Edit",
    print: "Print",
    create: "Create",
    cancle: "Cancle",
    logicnumber: "Logicnumber",
    update: "Update",
    ok: "OK",
    review: "Review",

  },

  //EmpIns

  empIns1: {
    office_name: "Office Name",
    office_address: "Address",
    change_office_name: "Change Office Name",
    change_office_name_phonetic: "Change Office Name(Phonetic)",
    change_name: "Change Name",
    change_name_phonetic: "Change Name(Phonetic)",
    date: "Date",
    change_date: "Change Date",
    business_start_day: "Business Start Day",
    change_address: "Change Address",
    change_address_phonetic: "Change Address(Phonetic)",
    reason: "Reason",
    overview_after_change_business: "Overview After Change Business",
    employment_insurance_section_name: "Employment Insurance Section Name",
    remark: "Remark",
    wages_deadline: "Wages Deadline",
    wage_payment_date: "Wage Payment Date",
    month: "Month",
    day: "Day",
    company_info: "Company Information",
    change_info: "Changed Information",
    cant_change: "You can not change the following company information",
    installation_date: "Installation Date",
    tel: "Phone No.",
    employment_ins_no: "Employment Insurance Insured Number",
    general_worker: "General Worker",
    daily_worker: "Daily Worker",
    person: "person",
    note: "Please enter only the category you want to change below.",
    dateRule: "Please fill date.",
    changeDateRule: "Please fill Deadline.",
    changeBeginDateRule: "Please fill Business Start Date.",
    this_month: "This Month",
    next_month: "Next Month",
  },

  empIns2: {
    office_name: "Office Name",
    remark: "Remark",
    installation_date: "Installation Date",
    emp_ins_section_name: "Employee Insurance Section Name",
    social_ins: "Social Ins",
    social_ins_health_part: "Health",
    social_ins_pension_part: "Pension",
    social_ins_accident_part: "Accident",
    enter_installation_date: "Please enter the installation date！",
    enter_name_in_charge: "Please enter the name of the section in charge of employment insurance！",
  },

  //new

  empIns3: {
    applicant: "Applicant",
    submit_date: "Submit Date",
    left_code: "Leave Job No.",
    left_date: "Leave Job Date",
    left_cause: "Leave Job Reason",
    re_date: "Reissue Date",
    things: "Granted Aspiration",
    name: "Name",
    things1: "Resign - 1",
    things2: "Resign - 2",
    loss: "Loss",
    damage: "Damage",
    emp_name: "Name",
  },

  empIns4de: {
    Selectemployee: "Select Employee",
    insuranceid: "Insurance ID",
    gettype: "Get Type",
    reasoncode: "Reason Code",
    salarytypecode: "Salary Type Code",
    salaryamount: "Salary Amount",
    acquisitiondate: "Acquisition Date",
    employmenttype: "Employment Type",
    profession_type: "Profession Type",
    inaugural_type: "Inaugural Type",
    week_work_time: "Week Work Time",
    contract_type: "Contract Type",
    contract_start_date: "Contract Start Date",
    contract_end_date: "Contract End Date",
    contract_update_type_code: "Contract Update Type Code",
    nationality: "Nationality",
    status_of_residence: "Residence Status",
    period_of_stay: "Period of Stay",
    qualification_activity_permission: "Qualification Activity Permission",
    working_category: "Working Category",
    old_insurance_type_code: "Old Insurance Type Code",
    number_check_flog: "Number Check Flog",
    name: "Name",
    mynumber: "My Number",
    Birthday: "Birthday",
    gender: "Gender",
    search: "Search",
    operating: "Operating",
    detail: "Detail",
    edit: "Edit",
    delete: "Delete",
    print: "Print",
    create: "Create",
    cancle: "Cancle",
    logicnumber: "Logicnumber",
    update: "Update",
    ok: "OK",
    review: "Review",
    basic1: "Basic Info",
    basic2: "Labor Info",
    pleaseselect: "Please Select",
    confirm: "Confirm",
    millom: "Ten Thousand",
    hour: "Hour",
    deleteorno: "Delete or Not",
    yes: "Yes",
    no: "No",
    deleteover: "Deleted",
    closeorno: "Close or Not",
    createover: "Created",
    faled: "Failed",
    over: "Over",
    check: "Check",
  },

  empIns5: {
    empInfo: "Employee Information",
    employee_id: "Employee Number",
    emp_name: "Name",
    category: "Category",
    mynum: "My Number",
    date: "Date",
    ins_no: "Insured No.",
    note: "Memo",
    new_mynum: "New My Number",
    new: "1.New",
    change: "2.Change",
    dateRule: "Please fill Date.",
    new_mynumRule: "Please fill new my number.",
    categoryRule: "Please select category.",
  },

  empIns6: {
    career_type: "Career Type",
    work_per_week: "Work per week",
    work_hour: "Work Hour",
    work_minute: "Work Minute",
    pay_amount: "Pay Amount",
    employ_period: "Employ Period",
    employ_period_date: "Employ Period Date",
    employ_contract_renewal: "Employ Contract Renewal",
    employ_period_oneyear: "Employ Period OneYear",
    proof_date: "Proof Date",
    has_allowance: "Has Allowance",
    application_date: "Application Date",
    employee_id: "Employee ID",
    name: "Employee Name",
    business_owner_proof: "Business Owner Proof",
    hour: "Hours",
    min: "Minutes",
    enter_career_type: "Please enter Career Type！",
  },

  empIns7: {
    office_name: "Office Name",
    address: "Address",
    chairman_name: "Chairman",
    date: "Date",
    abo_info: "Abolition Information",
    abo_category: "Abolition Category",
    category1: "1. Abolition of Business",
    category2: "4. Abolition of Business due to Business Integration",
    abo_reason: "Abolition Reason",
    abo_date: "Abolition Date",
    establish_no: "Office Number",
    establish_date: "Establish Date of Integrated Office",
    company_info: "Company Insformation",
    tel: "Phone Number",
    cant_change: "You can't change following information.",
    abo_dateRule: "Please fill the date of abolition.",
    business_codeRule: "Please fill Office Number.",
    business_dateRule: "Please fill establish date.",
    dateRule: "Please fill date.",
    businessHintTitle: "Office Number",
    businessHintMsg: "Please fill the business office number notified by the Public Employment Security Office from 4 to 13 digits.",
    emptyAlertTitle: "Entry Error",
    emptyAlertMsg: "Please fill all of requirements.",
  },
  empIns8de: {
    numberofpeople: "Number of people",
    occupation: "Occupation",
    numberofpeople2: "Number of people2",
    occupation2: "Occupation2",
    officename: "Office Name",
    address: "Address",
    date: "Date",

  },

  //new
  empIns9: {
    name_change_date: "Name Change Date",
    name: "Insurance's Name",
    new_name: "Insurance's New Name",
    cause: "Cause of Employee Insurance Loss",
    nation: "Nationality/Region",
    resident: "Residence",
    resident_period: "Residence Period",
    form16: "Temporary/Contract",
    form25: "Reason of Loss",
    form9: "Planned Recruitment",
    nospace: "1.Yes(No Space)",
    week_time: "Scheduled Working Hours per Week",
    time: "hours",
    new_namefrgn: "New Name(Phonetic)",
    wish: "Rsign Aspiration",
    changeOrloss: "0.Name Change/ 1.Report of Loss",
    yesno: "1.Yes 2.No",
    aus: "AUS-Austria",
    bra: "BRA-Brazil",
    mmr: "MMR-Myanmar",
    can: "CAN-Canada",
    chn: "CHN-China",
    fra: "FRA-France",
    deu: "DEU-Germany",
    hkg: "HKG-Hong Kong",
    ind: "IND-India",
    jpn: "JPN-Japan",
    kor: "KOR-Korea",
    phl: "PHL-Philippines",
    twn: "TWN-Taiwan",
    tha: "THA-Thai",
    usa: "USA-America",
    vnm: "VNM-Vietnam",
    r1: "01-Proffesser",
    r2: "02-Artist",
    r3: "03-Religious Activities",
    r4: "04-Journalist",
    r5: "05-No.1 Highly Skilled Professional",
    r6: "06-No.2 Highly Skilled Professional",
    r7: "07-Investor/Business Manager",
    r8: "08-Legal/Accounting Services",
    r9: "09-Medical Services",
    r10: "10-Researcher",
    r11: "11-Instructor",
    r12: "12-Engineer/Specialist in Humanities/ International Services",
    r13: "13-Intra-company Transferee",
    r14: "14-Nursing care service",
    r15: "15-Entertainer",
    r16: "16-Skilled Labor",
    r17: "17-No.1 Specified Skilled Worker",
    r18: "18-No.2 Specified Skilled Worker",
    r19: "19-No.1 Technical Intern Training",
    r20: "20-No.2 Technical Intern Training",
    r21: "21-No.3 Technical Intern Training",
    r22: "22-Cultural Activities",
    r23: "23-Temporary Visitor",
    r24: "24-Student",
    r25: "25-Trainee",
    r26: "26-Dependent",
    r27: "27-Designated Activities",
    r28: "28-Permanent Resident",
    r29: "29-Spouse or Child of Japanese National",
    r30: "30-Spouse or Child of Permanent Resident",
    r31: "31-Long-Term Resident",
    cause1: "1.Reason other than Leaving Job",
    cause2: "2.Leaving Job other than 3",
    cause3: "3.Leaving Job due to Business Owner",
    form1: "1.Mostly working outside of the office as the temporary or contract Worker",
    form2: "2.Not No.1",
  },
  empIns10de: {
    logicid: "Logic ID",
    leavetime: "Leave Time",
    createtime: "Create Time",

  },
  empIns12: {
    new_com_code: "Office number",
    transfer_day: "Transfer Date",
    memo: "Remark",
    date: "Report Date",
    employee_id: "Employee ID",
    name: "Employee Name",
    enter_new_com_code: "Please enter Office Number!",
    enter_transfer_day: "Please enter Transfer Day!",
    enter_date: "Please enter Report Date!",
  },

  empIns13: {
    employee_id: "Employee ID",
    emp_name: "Name",
    emp_name_pho: "Name[Roman]",
    national: "Nationality",
    birthday: "Birthday",
    branch: "Branch Number",
    re_employ: "First-time employment insurance insured",
    resident_card: "Resident Card No.",
    branch_noRule: "Fill in only if you attach it to the [Notification of Acquisition of Persons Covered by Employment Insurance (serialized form) Individual vote].",
    yes: "Yes",
    no: "No",
    attachHintTitle: "Branch Number",
    attachHintMsg: "Please fill in this only if you attach it to the (employment insurance insured acquisition report (serialized form) individual vote)",
    firstHintTitle: "Insured Number",
    firstHintMsg: "If the first to be insured by employment insurance, birthday will auto fill.",
  },

  empIns14: {
    resident_date: "Resident Date",
    license: "Has License",
    report_date: "Report Date",
    work_at_other_business: "Do you have other works?",
    employee_id: "Employee ID",
    name: "Employee Name",
    enter_resident_date: "Please enter Resident Date！",
  },



  //Social Ins

  attorney_power: {
    delegation_date: "Delegation Date",
    delegation_content: "Delegation Content",
    death_my_num: "Deceased's MyNumber",
    death_relation: "Deceased's Relationship with Delegator",
    death_name: "Deceased's Name",
    death_birth_date: "Deceased's Birthday",
    other_content: "Other Content",
    period_amount_wished: "Is there a method of grant such as enrollment period and expected amount of the pension?",
    kibou: "Wish",
    delegator: "Delegator",
    employee_id: "Employee ID",
    name: "Employee Name",
    trustee: "Trustee",
    trustee_name_furi: "Name Furigana",
    trustee_name: "Name",
    relation_with_delegator: "Relationship with Delegator",
    trustee_postcode: "Post Code",
    trustee_phone_no: "Phone Number",
    trustee_address: "Address",
    address: "City/Ward/County Name",
    hint_open1: "Select from the following items to be delegated, or fill in concretely.",
    hint_open2: "Please choose one of the following for the method of grant such as the enrollment period and expected amount of the pension.",
    enter_employee_id: "Please enter Employee ID",
  },
  pension_reissue: {
    report_date: "Report Date",
    phone_type: "Phone Type",
    reason: "Reason for Application",
    system_name: "System Name",
    acquisition_date: "Acquisition Date",
    loss_date: "Loss Date",
    employee_id: "Employee ID",
    name: "Employee Name",
    enter_reason: "Please enter Reason for Application",
    hint_open1: "Please enter the qualification date of the public pension system you are currently in or the last to join.",
    hint_open2: "Circle one of the following. 1. Lost: Lost 2. Damaged (dirty): Ripped or dirty *Please attach the damaged pension book to the document in this case. 9. Others: When the pension handbook is not issued, etc. (* Normally, it is not used)",
    hint_open3: "Select one of the following for the public pension system you are currently enrolled in. Also, if you are going to retire from the place where you worked and switch to the national pension, or if you are going to work for an employee pension insurance or seafarers insurance, the public pension system that the last place you worked for was a member. Please circle one of the following. 1. National pension: If you are currently enrolled in the national pension 2. Welfare pension insurance: If you are currently enrolled in welfare pension insurance, or if the last business establishment you worked for is welfare pension insurance. 3. Crew insurance: If you are currently enrolled in seafarer insurance, or if the last employable ship (business) is the shipowner's insurance company (business) 4. Mutual aid union: If you are currently a member of the mutual aid union, or the place where you last worked is the mutual aid group",
  },

  //Pension
  pensionbasicde: {
    member: "Member",
    april: "April",
    may: "May",
    june: "June",
    workingdays: "Workingdays",
    currency: "Currency",
    stocks: "Stocks",
    total: "Total",
    grandtotal: "Grandtotal",
    average: "Average",
    adjustedaverage: "Adjusted Average",
    holidaystarttime: "Holiday Start Time",
    holidayendtime: "Holiday End Time",
    retroactivepayment: "Retroactive Payment",
    retroactivepaymentmonth: "Retroactive Payment Month",
    latedelivery: "Late Delivery",
    Settlementday: "Settlement Day",
    payday: "Payday",
    entertime: "Enter Time",
    leaveofabsence: "Leave",
    companyinformation: "Company Information",
    pensionadmin: "Monthly Compensation Management",
    pensionbasic: "Monthly Reward",
    general: "Employee",
    Temporaryreturn: "Temporaryreturn",
    midcareer: "Mid-career",
    parttime: "Part-time",
    reducedworking: "Short Working Hours",
    leave: "Leave",
    Automaticcalculation: "Automatic Calculation",
    payoff: "Payoff",
    clear: "Clear",
    save: "Save",
    create: "Create",
    cancle: "Cancle",
    logicnumber: "Logic Number",
    update: "Update",
    ok: "OK",
    review: "Review",
    basic: "Basic",
    pleaseselect: "Please Select",
    confirm: "Confirm",
  },
  pensionadminde: {
    memberid: "Member ID",
    name: "Name",
    notice: "Notice",
    detail: "Detail",
    edit: "Edit",
    print: "Print",
    title: "Action",

  },

  //CalcuFunction

  //new
  NKHK: {
    name: "Reward Amount:",
    name_type: "Reward Amount Type",
    salary: "Salary",
    bonus: "Bonus",

    age: "Age:",
    under40: "Under 40 years old",
    over40: "Over 40 years old & under 65 years old",
    over65: "Over 65 years old",
    over70: "Over 70 years old",

    address: "Office Address:",
    hokkaido: "Hokkaido",
    aomori: "Aomori",
    iwate: "Iwate",
    miyagi: "Miyagi",
    akita: "Akita",
    yamagata: "Yamagata",
    fukushima: "Fukushima",
    ibaraki: "Ibaraki",
    tochigi: "Tochigi",
    gunma: "Gunma",
    saitama: "Saitama",
    chiba: "Chiba",
    tokyo: "Tokyo",
    kanagawa: "Kanagawa",
    niigata: "Niigata",
    toyama: "Toyama",
    ishikawa: "Ishikawa",
    fukui: "Fukui",
    yamanashi: "Yamanashi",
    nagano: "Nagano",
    gifu: "Gifu",
    shizuoka: "Shizuoka",
    aichi: "Aichi",
    mie: "Mie",
    shiga: "Shiga",
    kyoto: "Kyoto",
    osaka: "Osaka",
    hyogo: "Hyogo",
    nara: "Nara",
    wakayama: "Wakayama",
    tottori: "Tottori",
    shimane: "Shimane",
    okayama: "Okayama",
    hiroshima: "Horoshima",
    yamaguchi: "Yamaguchi",
    tokushima: "Tokushima",
    kagawa: "Kagawa",
    ehime: "Ehime",
    kochi: "Kochi",
    fukuoka: "Fukuoka",
    saga: "Saga",
    nagasaki: "Nagasaki",
    kumamoto: "Kumamoto",
    oita: "Oita",
    miyazaki: "Miyazaki",
    kagoshima: "Kagoshima",
    okinawa: "Okinawa",

    busType: "Business Type:",
    forestry: "Forestry",
    sea_fishery: "Sea Fisheries",
    net_fishery: "Fixed-net fishery or sea fish farming",
    mining: "Metal mining, non-metal mining",
    limestone_mining: "Limestone mining or dolomite mining",
    gas_mining: "Crude oil or natural gas mining",
    quarring: "Quarrying",
    other_mining: "Other mining",
    hydro: "Hydroelectric facility, new construction, tunnel,etc.",
    road: "Road construction business",
    paving: "Paving business",
    railway: "Railway or track new construction business",
    construction_business: "Construction Business",
    equipment: "Existing building equipment construction business",
    machinery: "Machinery assembly or installation business",
    other_construction: "Other construction business",
    food_manufacturing: "Food manufacturing industry",
    textile: "Textile industry or textile product manufacturing industry",
    wood: "Wood or wood product manufacturing industry",
    paper: "Pulp or paper manufacturing industry",
    printing: "Printing or bookbinding",
    chemical: "Chemical industry",
    glass: "Glass or cement manufacturing industry",
    concrete: "Concrete manufacturing",
    ceramic: "Ceramic product manufacturing industry",
    other_ceramic: "Other ceramic or stone and stone product manufacturing industry",
    metal: "Metal refining industry",
    non_metal: "Non-ferrous metal refining industry",
    metal_material: "Metal material manufacturing industry",
    foundry: "Foundry industry",
    metal_product: "Metal product manufacturing or metal processing industry",
    tableware: "Western tableware, cutlery, hand tools or general hardware manufacturing industry",
    metalwork: "Metalwork",
    machinery_part: "Machinery manufacturing industry",
    electric: "Electric machinery manufacturing industry",
    transportation_eqip: "Transportation machinery/equipment manufacturing industry",
    ship: "Ship manufacturing or repair business",
    clock: "Manufacturing industry of measuring instruments, optical machines, clocks, etc.",
    jewelry: "Manufacturing industry for precious metal products, jewelry, leather products, etc.",
    other_manufacturing: "Other manufacturing industries",
    transportation: "Transportation business",
    freight: "Freight handling business",
    cargo: "Port cargo handling business",
    harbor: "Harbor cargo handling business",
    gas_supply: "Electricity, gas, water supply or heat supply business",
    fisheries: "Fisheries other than agriculture or surface fisheries",
    cleaning: "Cleaning, cremation or slaughter business",
    building_maintenance: "Building maintenance",
    warehouse: "Warehouse business, security business, disinfection or pest control business",
    telecommunication: "Telecommunications, broadcasting, newspapers or publishing",
    lodging: "Wholesale/retail, restaurants or lodging",
    finance: "Finance business, insurance business or real estate business",
    other_various: "Other various businesses",
    ship_owner: "Ship owner's business",

    busTime: "Period",
    h16_8: "Until Heisei-16/8",
    h16_9: "From Heisei-16/9 to Heisei-17/8",
    h17_9: "From Heisei-17/9 to Heisei-18/8",
    h18_9: "From Heisei-18/9 to Heisei-19/8",
    h19_9: "From Heisei-19/9 to Heisei-20/8",
    h20_9: "From Heisei-20/9 to Heisei-21/8",
    h21_9: "From Heisei-21/9 to Heisei-22/8",
    h22_9: "From Heisei-22/9 to Heisei-23/8",
    h23_9: "From Heisei-23/9 to Heisei-24/8",
    h24_9: "From Heisei-24/9 to Heisei-25/8",
    h25_9: "From Heisei-25/9 to Heisei-26/8",
    h26_9: "From Heisei-26/9 to Heisei-27/8",
    h27_9: "From Heisei-27/9 to Heisei-28/8",
    h28_9: "For Heisei-28/9",
    h28_10: "From Heisei-28/10 to Heisei-29/8",
    h29_9: "After Heisei-29/9",

    resource: "Business:",
    general: "General",
    agriculture: "Manufacturing of Agriculture, Forestry and Fisheries, Sake",
    construction: "Construction",

    calculate: "Total",
    clear: "Clear",

    yen: "￥",

    pension_result: "Employees' Pension Insurance Calculation Result:",
    standard_reward: "Standard Reward Amount：",
    insurance_fee: "Insurance Fee：",
    emp: "For Employee：",

    emp_ins_result: "Employment Insurance Premium for Employees Calculation Result:",
    emp_burden: "Employee Burden：",
    chairman_burden: "Business Owner's Burden：",
    emp_ins_fee: "Employment Insurance Premium：",

    accident_ins_result: "Labor Accident Insurance Premium Calculation Result:",
    accident_ins_fee: "Industrial Accident Insurance Premium：",

    health_ins_result: "Health Insurance Premium Calculation Result:",
    ins_type: "Insurance Type：",
    rate: "Rate",
    health_ins: "Health Insurance：",
    nurse_ins: "Long-term Care Insurance：",

    subtotal: "Subtotal：",
    ins_total: "Total Insurance：",

    alert: "The input is incorrect. Please re-enter.",
  },

  //new
  JDSLoan: {
    moneyAmount: "Please enter the desired loan amount within 10 million yen.:",
    loanAmount: "Please enter the desired amount for bonus repayment within 50% of the loan amount.:",
    desiredPeriod: "Desired loan period (Please enter within 6 months to 10 years.):",

    calculate: "Calculate",
    clear: "Clear",

    interest_rate: "Interest Rate:",
    S1: "Monthly Repayment Amount:",
    S2: "Bonus Month Repayment Amount:",

    ten_thousand: "Ten Thousand Yen",
    yen: "￥",
    year: "Year",
    month: "Month",

    p1Alert: "Some items have not been entered！！",
    p2Alert: "Please enter the repayment period！！",

    err_msg1: "Somethig Wrong!!",
    err_msg2: "The loan amount is incorrect！！",
    err_msg3: "The repayment period is incorrect！！",
    wrong_bonus: "Wrong bonus payment amount！！",
    over_bonus: "The maximum bonus payment amount is、",
    is_ten_thousand: " ten thousand yen！！",
    not_number: "Some items are not numbers!!",
    wrong_rate: "There is an error in the input value of the interest rate!!",
  },

  //new
  monthLoan: {
    fill_month: "Please enter month",
    search: "Search",
    month: "Month",
    permanent: "Permanent",
    officer: "Officer",
    temporary: "Temporary",
    total: "Total",

    people: "People",
    loan: "Loan",

    fill: "Please Fill."
  },







};


// WEBPACK FOOTER //
// ./src/i18n/locale/en.js